import request from '@/utils/request'

// 车辆道闸开关
export function updateOfficeGateOne(data) {
  const { value, ...params } = data
  return request.get('/equip/handleGate', {
    params: {
      ...params,
      operation: value,
    }
  })
}

// 开关道闸接口  /barrierGate/openBarrier/{gate}/{opt}
export function updateGate(data) {
  const { gate, opt, ...params } = data
  return request.get(`/barrierGate/openBarrier/${gate}/${opt}`, {
    params
  })
}

// 开关平推门接口
export function entranceDoorGate(data) {
  const { opt, ...params } = data
  return request.get(`/barrierGate/entranceDoorGate/${opt}`, {
    params
  })
}

// 车辆道闸开关
export function updateMaterialGateOne(data) {
  const { value, ...params } = data
  return request.get('/equip/handleWestGate', {
    params: {
      ...params,
      operation: value,
    }
  })
}

// 获取货车道闸列表
export function getCarHistoryList(params) {
  return request.get('/carAccessRecord/list', { params })
}

// 获取货车道闸列表
export function getTruckHistoryList(params) {
  return request.get('/truckAccess/list', { params })
}

